import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ApplicantNotesTableDefinitionZod } from '../tables';

type Arguments = {
    applicantIds: string[];
    id: string;
    position?: number;
    changeType: string;
};
const schemaApplicantNotes = z.object({
    applicantId: z.string().nullable(),
    notes: z.array(ApplicantNotesTableDefinitionZod.shape.notes.element.merge(z.object({ applicantId: z.string() }))),
});
export const schemaLoanRequestResolver_GetApplicantNotes = z.object({
    applicant1Notes: schemaApplicantNotes,
    applicant2Notes: schemaApplicantNotes,
});

export type SchemaLoanRequestResolver_GetApplicantNotes = z.infer<typeof schemaLoanRequestResolver_GetApplicantNotes>;

export type LoanRequestResolver_GetApplicantNotes = Resolver<Arguments, SchemaLoanRequestResolver_GetApplicantNotes>;
